export default "__VITE_ASSET__CNgegqDR__"